export default __webpack_public_path__ + "f8bbb628f399681c520e40a9c1dda086.svg";